/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ChildDiaryFileFileTypeEnum } from './childDiaryFileFileTypeEnum';

export interface ChildDiaryFile { 
    readonly id: string;
    fileType: ChildDiaryFileFileTypeEnum;
    fileName: string;
    fileSize: number;
    duration?: number;
    readonly url: string;
    readonly thumbnailUrl: string;
    /**
     * Browser-playable MP4 once converted; None for photos and for videos still being processed.
     */
    readonly videoUrl: string;
    readonly processing: boolean;
}